import { useParams } from "react-router-dom";

function useIdParam() {
  const { userId } = useParams();
  return userId;
}

export default useIdParam;
